import React, { Fragment, useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Backdrop, Box, Card, Chip, Divider, Typography, useMediaQuery } from '@mui/material'
import axios from 'axios'
import { DOMAIN } from '../../utils/api'
import { handleError } from '../../utils/error'
import { currentUserActions } from '../../redux/store'
import WbSunnyIcon from '@mui/icons-material/WbSunny'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import PickDateWithoutShiftGrow from '../../components/PickDateWithoutShiftGrow'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getFromStorage } from '../../utils/storage'
import { mainGreen, mainRed } from '../../utils/color'
import { getTextOfInternalSale } from '../../utils/helper'

export default function ViewStockHistory() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const token = getFromStorage('current-user')?.accessToken
	const { currentUser } = useSelector((state) => state.currentUser)
	const [historyByTime, setHistoryByTime] = useState([])
	const [shift, setShift] = useState({ morning: true, afternoon: false })
	const [currentImage, setCurrentImage] = useState(null)
	const [isViewerOpen, setIsViewerOpen] = useState(false)

	const today = new Date()

	const [timePick, setTimePick] = useState({
		date: today.getDate()?.toString(),
		month: (today.getMonth() + 1)?.toString(),
		year: today.getFullYear()?.toString(),
	})

	const setTime = (time) => {
		setTimePick(time)
	}

	const openImageViewer = (photo) => {
		setCurrentImage(photo)
		setIsViewerOpen(true)
	}

	const closeImageViewer = () => {
		setCurrentImage(null)
		setIsViewerOpen(false)
	}

	const getHistoryByTime = useCallback(
		async function () {
			const { date, month, year } = timePick
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/view-stock-history/${currentUser.store}?shift=${shift.morning}&date=${date}&month=${month}&year=${year}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
				})
				setHistoryByTime(response.data)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, navigate, timePick, shift.morning, dispatch, currentUser.store],
	)

	useEffect(() => {
		getHistoryByTime()
	}, [getHistoryByTime])

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 992,
					margin: '0 auto',
				}}>
				{currentUser?.permission.includes('viewStockHistory') && (
					<Card sx={{ padding: '10px', mb: 2 }}>
						<Typography
							sx={{
								textAlign: 'center',
								fontSize: '18px',
								fontWeight: 'bold',
								mb: 1,
							}}>
							LỊCH SỬ KHO
						</Typography>
						<PickDateWithoutShiftGrow time={timePick} setTime={setTime} />
						<Box display='flex' justifyContent='center'>
							<Chip
								onClick={() => {
									if (shift.morning === false) {
										setShift({ morning: true, afternoon: false })
									}
								}}
								size='small'
								sx={{
									cursor: 'pointer',
									mr: 4,
									background: shift.morning ? mainGreen : undefined,
									color: shift.morning ? '#fff' : '#000',
									'&:hover': {
										background: shift.morning ? mainGreen : undefined,
										color: shift.morning ? '#fff' : '#000',
									},
								}}
								label={
									<Typography
										sx={{
											fontSize: '14px',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											lineHeight: 1.3,
										}}>
										{' '}
										<WbSunnyIcon sx={{ mr: 1, fontSize: '20px' }} /> Sáng
									</Typography>
								}
							/>
							<Chip
								onClick={() => {
									if (shift.afternoon === false) {
										setShift({ morning: false, afternoon: true })
									}
								}}
								size='small'
								sx={{
									cursor: 'pointer',
									background: shift.afternoon ? mainGreen : undefined,
									color: shift.afternoon ? '#fff' : '#000',
									'&:hover': {
										background: shift.afternoon ? mainGreen : undefined,
										color: shift.afternoon ? '#fff' : '#000',
									},
								}}
								label={
									<Typography
										sx={{
											fontSize: '14px',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											lineHeight: 1.3,
										}}>
										{' '}
										<DarkModeIcon sx={{ mr: 1, fontSize: '20px' }} /> Chiều
									</Typography>
								}
							/>
						</Box>
						{historyByTime?.filter(
							(item) =>
								item.action !== 'checkProductStock' &&
								item.action !== 'checkFreshStock' &&
								!(item.action === 'confirmCheckProductStock' && !item.checkStockRecord) &&
								!(item.action === 'confirmCheckFreshStock' && !item.checkStockRecord),
						)?.length === 0 && (
							<Typography sx={{ textAlign: 'center', fontStyle: 'italic', mt: 2 }}>(Chưa có dữ liệu)</Typography>
						)}
						{historyByTime?.filter(
							(item) =>
								item.action !== 'checkProductStock' &&
								item.action !== 'checkFreshStock' &&
								!(item.action === 'confirmCheckProductStock' && !item.checkStockRecord) &&
								!(item.action === 'confirmCheckFreshStock' && !item.checkStockRecord),
						)?.length > 0 && (
							<Typography
								sx={{
									textAlign: 'center',
									fontSize: '18px',
									fontWeight: 'bold',
									mb: 1,
									mt: 1,
								}}>
								KHO CHÍN
							</Typography>
						)}

						<Box sx={{ mt: 2 }}>
							{historyByTime
								?.filter(
									(item) =>
										item.action !== 'checkProductStock' &&
										!(item.action === 'confirmCheckProductStock' && !item.checkStockRecord) &&
										item.action !== 'confirmCheckFreshStock' &&
										item.action !== 'checkFreshStock' &&
										item.action !== 'freshExport' &&
										item.action !== 'importFromMainStock' &&
										item.action !== 'reImportFresh',
								)
								?.filter(
									(item) =>
										!((item.action === 'crossStoreSell' || item.action === 'crossStoreBuy') && !item?.cookedBalance),
								)
								?.map((item, index) => {
									return (
										<Fragment key={index}>
											<Typography sx={{ textAlign: 'left', mt: 1 }}>
												{(item.action === 'soldProduct' || item.action === 'reImportCooked') && (
													<span>
														<b>
															{item?.shiftCode}
															{item?.shiftIndex}-{item?.shiftDay}.
														</b>{' '}
													</span>
												)}{' '}
												<b>{item.user?.name}</b>{' '}
												{item?.action === 'confirmCheckProductStock' && item?.checkStockRecord && (
													<>
														<span style={{ color: mainGreen }}>
															kiểm kho chín <b>{item?.quantity?.toFixed(1)}kg</b>
														</span>
														. Hệ thống{' '}
														<span style={{ color: mainGreen }}>
															<b>
																{item?.checkStockSystem?.toFixed(1)}
																kg.
															</b>
														</span>{' '}
														Chênh lệch:{' '}
														{item?.quantity - item?.checkStockSystem > 0 ? (
															<b>+{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
														) : (
															<b>{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
														)}
														kg. <b>{item?.confirmCheckStock?.user.name}</b> đã duyệt.
													</>
												)}
												{item.action === 'soldProduct' && (
													<span style={{ color: mainRed }}>
														xuất kho <b>{item?.quantity}kg.</b>
													</span>
												)}
												{item.action === 'cooked' && (
													<span>
														nướng <b>{item?.beforeCookedQuantity?.toFixed(1)}</b>
														kg sống ra <b>{item?.quantity.toFixed(1)}kg </b>
														chín.
													</span>
												)}
												{item.action === 'crossStoreSell' || item.action === 'crossStoreBuy'
													? getTextOfInternalSale(item, 'kg')
													: null}
												{item.action === 'reImportCooked' && (
													<span style={{ color: mainGreen }}>
														hủy đơn tái nhập <b>{item?.quantity?.toFixed(1)}kg </b>nem. ({item?.deleteReason}).
													</span>
												)}{' '}
												{(item?.cookedBalance || item?.cookedBalance === 0) && (
													<>
														Tồn chín{' '}
														<b>
															{item?.cookedBalance?.toFixed(1)}
															kg
														</b>
													</>
												)}
												{item?.reImportCookedReason && (
													<span
														style={{
															display: 'block',
															fontStyle: 'italic',
															margin: 0,
														}}>
														Lý do: {item?.reImportCookedReason}
													</span>
												)}
											</Typography>
											<Box display='flex' justifyContent='flex-end' alignItems='flex-end' sx={{ mb: 1 }}>
												{item?.deletePhoto && (
													<img
														loading='lazy'
														src={item?.deletePhoto}
														onClick={() => {
															openImageViewer(item?.deletePhoto)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)}
												{item?.deleteMultiPhoto?.map((img, index) => {
													return (
														<img
															loading='lazy'
															key={index}
															src={img}
															onClick={(e) => {
																openImageViewer(img)
															}}
															width='30'
															height='30'
															style={{
																marginRight: '8px',
																marginTop: '2px',
																cursor: 'pointer',
															}}
															alt=''
														/>
													)
												})}
												{item?.checkStockPicture && (
													<img
														loading='lazy'
														src={item?.checkStockPicture}
														onClick={() => {
															openImageViewer(item?.checkStockPicture)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)}
												{item?.checkStockMultiPicture?.map((img, index) => {
													return (
														<img
															loading='lazy'
															key={index}
															src={img}
															onClick={(e) => {
																openImageViewer(img)
															}}
															width='30'
															height='30'
															style={{
																marginRight: '8px',
																marginTop: '2px',
																cursor: 'pointer',
															}}
															alt=''
														/>
													)
												})}
												{item?.crossStoreOrder?.order?.photoAttaches?.map((img, index) => {
													return (
														<img
															loading='lazy'
															key={index}
															src={img}
															onClick={(e) => openImageViewer(img)}
															width='30'
															height='30'
															style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer', objectFit: 'cover' }}
															alt=''
														/>
													)
												})}
												<Typography
													style={{
														fontStyle: 'italic',
														fontSize: '12px',
														textAlign: 'right',
													}}>
													- {item?.timeStamp} -{' '}
													{item?.confirmCheckStock && (
														<span style={{ color: mainRed }}>Duyệt: {item?.confirmCheckStock.timeStamp}</span>
													)}
												</Typography>{' '}
											</Box>

											<Divider />
										</Fragment>
									)
								})}
						</Box>
						{historyByTime?.filter(
							(item) =>
								item.action !== 'checkProductStock' &&
								item.action !== 'checkFreshStock' &&
								!(item.action === 'confirmCheckProductStock' && !item.checkStockRecord) &&
								!(item.action === 'confirmCheckFreshStock' && !item.checkStockRecord),
						)?.length > 0 && (
							<>
								<Divider sx={{ mb: 2, height: '2px', background: mainGreen }} />
								<Typography
									sx={{
										textAlign: 'center',
										fontSize: '18px',
										fontWeight: 'bold',
										mb: 1,
										mt: 1,
									}}>
									KHO SỐNG
								</Typography>
							</>
						)}
						<Box sx={{ mt: 2 }}>
							{historyByTime
								?.filter(
									(item) =>
										item.action !== 'checkProductStock' &&
										item.action !== 'checkFreshStock' &&
										item.action !== 'confirmCheckProductStock' &&
										!(item.action === 'confirmCheckFreshStock' && !item.checkStockRecord) &&
										item.action !== 'soldProduct' &&
										item.action !== 'cooked' &&
										item.action !== 'reImportCooked',
								)
								?.filter(
									(item) =>
										!((item.action === 'crossStoreSell' || item.action === 'crossStoreBuy') && !item?.freshBalance),
								)
								?.map((item, index) => {
									return (
										<Fragment key={index}>
											<Typography sx={{ textAlign: 'left', mt: 1 }}>
												<b>{item.user?.name}</b>{' '}
												{item?.action === 'confirmCheckFreshStock' && item?.checkStockRecord && (
													<>
														<span style={{ color: mainGreen }}>
															kiểm kho sống <b>{item?.quantity?.toFixed(1)}kg</b>
														</span>
														. Hệ thống{' '}
														<span style={{ color: mainGreen }}>
															<b>
																{item?.checkStockSystem?.toFixed(1)}
																kg.
															</b>
														</span>{' '}
														Chênh lệch:{' '}
														{item?.quantity - item?.checkStockSystem > 0 ? (
															<b>+{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
														) : (
															<b>{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
														)}
														kg. <b>{item?.confirmCheckStock?.user.name}</b> đã duyệt.
													</>
												)}
												{item?.action === 'importFromMainStock' && (
													<span>
														nhập <b>{item?.quantity?.toFixed(1)}kg</b> từ kho tổng.
													</span>
												)}
												{item?.action === 'freshExport' && (
													<span style={{ color: mainRed }}>
														xuất <b>{item?.quantity?.toFixed(1)}kg.</b>
													</span>
												)}{' '}
												{item?.action === 'reImportFresh' && (
													<span style={{ color: mainGreen }}>
														tái nhập <b>{item?.quantity?.toFixed(1)}kg.</b>
													</span>
												)}{' '}
												{item.action === 'crossStoreSell' || item.action === 'crossStoreBuy'
													? getTextOfInternalSale(item, 'kg')
													: null}{' '}
												{(item?.freshBalance || item?.freshBalance === 0) && (
													<>
														Tồn sống{' '}
														<b>
															{item?.freshBalance?.toFixed(1)}
															kg
														</b>
													</>
												)}
												{item?.reImportFreshReason && (
													<span
														style={{
															display: 'block',
															fontStyle: 'italic',
															margin: 0,
														}}>
														Lý do: {item?.reImportFreshReason}
													</span>
												)}
											</Typography>

											<Box display='flex' justifyContent='flex-end' alignItems='flex-end' sx={{ mb: 1 }}>
												{item?.importFreshPhoto?.map((img, index) => {
													return (
														<img
															loading='lazy'
															key={index}
															src={img}
															onClick={(e) => {
																openImageViewer(img)
															}}
															width='30'
															height='30'
															style={{
																marginRight: '8px',
																marginTop: '2px',
																cursor: 'pointer',
															}}
															alt=''
														/>
													)
												})}
												{item?.checkStockPicture && (
													<img
														loading='lazy'
														src={item?.checkStockPicture}
														onClick={() => {
															openImageViewer(item?.checkStockPicture)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)}
												{item?.checkStockMultiPicture?.map((img, index) => {
													return (
														<img
															loading='lazy'
															key={index}
															src={img}
															onClick={(e) => {
																openImageViewer(img)
															}}
															width='30'
															height='30'
															style={{
																marginRight: '8px',
																marginTop: '2px',
																cursor: 'pointer',
															}}
															alt=''
														/>
													)
												})}
												{item?.freshExportPhoto?.map((img, index) => {
													return (
														<img
															loading='lazy'
															key={index}
															src={img}
															onClick={(e) => {
																openImageViewer(img)
															}}
															width='30'
															height='30'
															style={{
																marginRight: '8px',
																marginTop: '2px',
																cursor: 'pointer',
															}}
															alt=''
														/>
													)
												})}
												{item?.reImportFreshPhoto?.map((img, index) => {
													return (
														<img
															loading='lazy'
															key={index}
															src={img}
															onClick={(e) => {
																openImageViewer(img)
															}}
															width='30'
															height='30'
															style={{
																marginRight: '8px',
																marginTop: '2px',
																cursor: 'pointer',
															}}
															alt=''
														/>
													)
												})}
												{item?.crossStoreOrder?.order?.photoAttaches?.map((img, index) => {
													return (
														<img
															loading='lazy'
															key={index}
															src={img}
															onClick={(e) => openImageViewer(img)}
															width='30'
															height='30'
															style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer', objectFit: 'cover' }}
															alt=''
														/>
													)
												})}
												<Typography
													style={{
														fontStyle: 'italic',
														fontSize: '12px',
														textAlign: 'right',
													}}>
													- {item?.timeStamp} -{' '}
													{item?.confirmCheckStock && (
														<span style={{ color: mainRed }}>Duyệt: {item?.confirmCheckStock.timeStamp}</span>
													)}
												</Typography>{' '}
											</Box>
											<Divider />
										</Fragment>
									)
								})}
						</Box>
						<Backdrop
							sx={{
								color: '#fff',
								zIndex: 999,
								left: mediaMd ? 300 : 0,
							}}
							open={isViewerOpen}
							onClick={closeImageViewer}>
							<img
								loading='lazy'
								src={currentImage}
								alt='attach'
								style={{
									maxHeight: '70%',
									maxWidth: '90%',
								}}
								onClick={(e) => {
									e.stopPropagation()
								}}
							/>
						</Backdrop>
					</Card>
				)}
			</Box>
		</UserLayout>
	)
}
